export enum SelectType {
  TargetFrom = "targetFrom",
  TargetTo = "targetTo",
  Subject = "subject",
}
